const getDate = () => {
    const now = new Date();
    return now.toISOString().split("T")[0].replace(/-/g, "");
};

const replaceNameTemplate = (template, nameData) => {
    const empty = "\x00";
    const result = template.replace(
        /#\{([^a-zA-Z]?)(\w+)\}/g,
        (_, separator, key) => {
            if (key === "date") {
                return getDate();
            }

            const normalizedKey = key.toLowerCase();
            const value = nameData[normalizedKey];
            if (value !== undefined) {
                const sep = separator || "-";
                const listValue = [...nameData[normalizedKey]];
                const transformed = listValue.map(value => {
                    if (key === key.toUpperCase()) {
                        return value.toUpperCase();
                    }
                    if (/^[A-Z]/.test(key)) {
                        return (
                            value.charAt(0).toUpperCase() +
                            value.slice(1).toLowerCase()
                        );
                    }
                    return value;
                });
                return transformed.join(sep);
            }
            return empty;
        }
    );

    return result.replace(/[^a-zA-Z0-9\x00]*\x00[^a-zA-Z0-9\x00]*/g, match => {
        const right = match.match(/\x00([^a-zA-Z0-9\x00]*)/)?.[1] ?? "";
        const left = match.match(/([^a-zA-Z0-9\x00]*)\x00/)?.[1] ?? "";
        return left ? right : "";
    });
};

const generateCommands = cuttlefishConfig => {
    if (!cuttlefishConfig.nodes || !cuttlefishConfig.edges) {
        return;
    }
    const builds = [];
    const nameData = {};

    const adjencency = cuttlefishConfig.edges.reduce((acc, edge) => {
        if (!acc[edge.source]) {
            acc[edge.source] = [];
        }
        acc[edge.source].push(edge.target);
        return acc;
    }, {});

    const nodeMap = Object.fromEntries(
        cuttlefishConfig.nodes.map(node => [node.id, node])
    );
    const startNode = nodeMap["start"];
    if (!startNode) {
        throw new Error("Start node not found in the graph.");
    }

    const traverse = (
        node,
        currentPath,
        currentTags,
        currentFlags,
        nameData,
        currentSize
    ) => {
        const newPath = [...currentPath, node.id];
        const newTags = [...currentTags];
        const newFlags = [...currentFlags];
        const newNameData = { ...nameData };
        let newSize = currentSize;

        switch (node.type) {
            case "size": {
                newNameData["size"] = new Set([`${node.data.value}MB`]);
                const size = Number(node.data.value);
                newSize = Number.isFinite(size) ? size : undefined;
                const flag = `--${node.data.name} ${node.data.value}`;
                if (!newFlags.includes(flag)) {
                    newFlags.push(flag);
                }
                break;
            }
            case "boolean":
            case "number": {
                const flag = `--${node.data.name} ${node.data.value}`;
                if (!newFlags.includes(flag)) {
                    newFlags.push(flag);
                }
                break;
            }
            default: {
                if (node.data?.value && !newTags.includes(node.data.value)) {
                    let listName = node.data.name.toLowerCase();
                    if (node.type === "network") {
                        listName = "network";
                    }
                    if (!newNameData[listName]) {
                        newNameData[listName] = new Set();
                    }
                    const values = node.data.value.split(",");
                    values.forEach(element => {
                        newNameData[listName].add(element);
                    });
                    newTags.push(node.data.value);
                }
            }
        }

        if (node.type === "network") {
            const name = replaceNameTemplate(
                cuttlefishConfig.nameTemplate,
                newNameData
            );
            if (name !== undefined && name !== "") {
                newFlags.push(`--name '${name}'`);
            }
            const buildPath = replaceNameTemplate(
                cuttlefishConfig.buildPathTemplate,
                newNameData
            );
            if (buildPath !== undefined && buildPath !== "") {
                newFlags.push(`--path '${buildPath}'`);
            }
            const network = node.data.value;
            const command =
                `gulp ${network} -c '${newTags.join(",")}' ${newFlags.join(" ")}`.trim();
            builds.push({
                id: builds.length + 1,
                enabled: true,
                tags: newTags,
                name: name,
                command: command,
                network: network,
                size: newSize
            });
            return;
        }

        for (const targetId of adjencency[node.id] ?? []) {
            const next = nodeMap[targetId];
            if (next) {
                traverse(
                    next,
                    newPath,
                    newTags,
                    newFlags,
                    newNameData,
                    newSize
                );
            }
        }
    };

    traverse(startNode, [], [], [], nameData, undefined);
    return builds;
};

module.exports = {
    replaceNameTemplate: replaceNameTemplate,
    generateCommands: generateCommands
};
